import './all.css'
import React from "react";
const fontawesome: React.FC = () => {
    return (
        <></>
    );
};
export { fontawesome };
export default fontawesome;